<template>
    <BusinessOmniplayEventsCoreVue :dateDimension="dateDimension"></BusinessOmniplayEventsCoreVue>
</template>


<script>


import BusinessOmniplayEventsCoreVue, { BusinessOmniplayEventsCore } from '@/views/events/core/BusinessOmniplayEventsCore.vue';
import { BusinessOmniplayEventsPresta } from '@/router/routeNames';
import dimensionEnum from '@/model/dimensionEnum';



export default {
    name: BusinessOmniplayEventsPresta,
    data() {
        return {
            dateDimension: dimensionEnum.OMNIPLAYEVENT_EVENTBUSINESSDATE
        };
    },
    mounted() {
    },
    computed: {},
    methods: {},
    components: { BusinessOmniplayEventsCoreVue }
}

</script>